export default __webpack_public_path__ + "static/media/friends.d7b4df30.png";